const {KitModule} = window;

// Both image layouts can enter the viewport before a lazy player is upgraded.
export default class LottieModule extends KitModule {
  constructor($element) {
    super($element, {observer: {threshold: 0.5}});
    this.$element.addEventListener('lottie-ready', () => this.bindLottiePlayer());
    this.bindLottiePlayer();
  }

  bindLottiePlayer() {
    const player = this.$lottiePlayer?.dotLottie;
    if (!player || this.player === player) return;
    this.player = player;
    // The viewport callback can precede lazy runtime/asset initialization.
    if (player.isLoaded && this.$element.dataset.isIntersectingViewport === 'true') {
      player.play();
      player.unfreeze();
    }
    player.addEventListener('load', () => {
      if (this.$element.dataset.isIntersectingViewport === 'true') this.onViewportEnter();
    });
  }

  onViewportEnter() {
    this.bindLottiePlayer();
    this.player?.play();
    this.player?.unfreeze();
  }
}
